import { Skeleton, Box, styled } from "@mui/material";

const UserFooterSkeleton = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const SidebarUserMenuSkeleton = () => (
  <UserFooterSkeleton>
    <Skeleton variant="circular" width={34} height={34} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="60%" height={18} />
      <Skeleton variant="text" width="40%" height={14} />
    </Box>
  </UserFooterSkeleton>
);